import SubscriptionType from '../constants/subscription-type';

function isFreeEcommercePlanType(type: string): boolean {
  return (
    type === SubscriptionType.B2C_ECOMMERCE_FREE || type === SubscriptionType.WL_ECOMMERCE_FREE
  );
}

export default isFreeEcommercePlanType;
